<app-header 
  [icon]="'arrow_back_ios'"
  (iconClickedEvent)="back()">
</app-header>
<div class="container">
  <div class="image">
    <mat-icon>person</mat-icon>
  </div>
  <div class="info-container">
    <mat-icon matRipple [class]="isEditing ? 'editing' : 'edit'" (click)="editToggle()">{{ isEditing ? 'check' : 'edit'
      }}</mat-icon>

    @if(!loading()){
    @if(psychologist()){
    <span class="profile">{{ 'profiles.psychologist' | translate }}</span>
    <span class="profile-status">{{STATUS[psychologist()?.status || ''].label | translate}}</span>
    <span class="profile-status">{{PLANS[psychologist()?.subscription_plan || ''].label | translate}}</span>
    }@else {
    <span class="profile">{{ getUserProfile().label | translate }}</span>
    }
    }

    <span class="mail">{{authService.user()?.email}}</span>
    <app-input [label]="'labels.first_name' | translate" [placeholder]="'placeholders.first_name' | translate"
      [formControl]="firstNameControl" type="text"></app-input>

    <app-input [label]="'labels.last_name' | translate" [placeholder]="'placeholders.last_name' | translate"
      [formControl]="lastNameControl" type="text"></app-input>

    <app-input [label]="'labels.birthdate' | translate" [placeholder]="'placeholders.birthdate' | translate"
      [formControl]="birthdateControl" type="date"></app-input>

    <app-input [label]="'labels.preferred_language' | translate"
      [placeholder]="'placeholders.select_language' | translate" [formControl]="searchControl"
      [autocompleteList]="LANGUAGES" [autocompleteOptionLabel]="'name'"
      [autocompleteDisplayFunction]="autocompleteDisplayFn" type="autocomplete"></app-input>

    <div class="phone-container">
      <img src="/imgs/wapp_logo.png" alt="Icon from Whatsapp">
      <p>{{ 'complete-account.wapp' | translate }}</p>

      <p class="label">{{ 'labels.country_code' | translate }}</p>
      <mat-form-field appearance="outline">
        <mat-select [formControl]="dialCodeControl">
          @for (group of COUNTRY_GROUPS; track group.name) {
          <mat-optgroup [label]="group.name | translate">
            @for (item of sortCountriesByTranslatedName(group.countries); track item.iso) {
            <mat-option [value]="item.dial_code">{{item.name | translate}} {{'('+item.dial_code+')'}}</mat-option>
            }
          </mat-optgroup>
          }
        </mat-select>
      </mat-form-field>
      @if (
      dialCodeControl.invalid
      && dialCodeControl.errors
      && (dialCodeControl.touched || dialCodeControl.dirty)
      ) {
      @if (dialCodeControl.errors['required']) {
      <div class="error">
        {{ 'errors.field_required' | translate }}
      </div>
      } @else {
      <div class="error">
        {{ 'errors.invalid_field' | translate }}
      </div>
      }
      }

      <app-input [label]="'labels.phone' | translate" [placeholder]="'placeholders.phone' | translate"
        [formControl]="phoneNumberControl" type="tel"></app-input>
    </div>

    
    <div class="actions-container">
      <app-button 
        [buttonLabel]="'buttons.cancel' | translate"
        [buttonType]="BUTTON_TYPES.OUTLINED" 
        [buttonDisabled]="false"
        (click)="back()">
      </app-button>

      @if (isEditing) {  
        <app-button
          [buttonLabel]="'buttons.save' | translate"
          [buttonType]="BUTTON_TYPES.REGULAR" 
          [buttonDisabled]="isFormInvalid()"
          (click)="editToggle()">
        </app-button>
      }
    </div>

  </div>    
</div>